import { TypographySettings } from '@theme/globals/typography';

const buildTextSizes = () => {
  const sizes: {
    [key: string]: {
      size: string;
      height: string;
      family: string;
      weight: number;
    };
  } = {};
  for (const [key, value] of Object.entries(TypographySettings)) {
    sizes[key] = {
      family: value.family,
      size: value.size,
      height: value.height,
      weight: value.weight,
    };
  }
  return sizes;
};

const text = {
  ...buildTextSizes(),
  skeleton: {
    width: {
      width: '100px',
      min: '100px',
    },
    margin: {
      vertical: 'xsmall',
    },
    colors: {
      dark: ['border', 'border'],
      light: ['background-front', 'background-back'],
    },
  },
};

export default text;
